import { Pipe, PipeTransform } from '@angular/core';
import { of, Observable, combineLatest, iif } from 'rxjs';
import { Store } from '@ngxs/store';
import { SettingsState } from '../store/settings/settings.state';
import { CustomColumnNamesState } from '../store/dashboard/custom-column-names/custom-column-names.state';
import { map, switchMap } from 'rxjs/operators';
import { CustomColumnSettingsEntryRemoteDto } from 'src/generated/signalR/custom-column-settings-entry-remote-dto';
import _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
   name: 'customColumnName',
})
export class CustomColumnNamePipe implements PipeTransform {
   constructor(private store: Store, private translationService: TranslateService) {}

   transform(columnKey: string, fallbackTranslationKey: string = '-'): Observable<string> {
      return combineLatest([of(columnKey), this.store.select(CustomColumnNamesState.getCustomColumnSettings)]).pipe(
         map(([columnKey1, customColumnNamesState]) => {
            const result: CustomColumnSettingsEntryRemoteDto = _(customColumnNamesState)
               .filter((column) => column.key === columnKey1)
               .head();
            if (_.isNil(result)) {
               return null;
            }
            return _.isEmpty(result.custom) ? result.default : result.custom;
         }),
         switchMap((costumColumnTitle) => iif(() => _.isNil(costumColumnTitle), this.translationService.get(fallbackTranslationKey), of(costumColumnTitle)))
      );
   }
}
